export class ForgotPasswd
{

	constructor(id)
	{
		if (!!id) {
			this.id = id
            this.$parent = $('#' + this.id).closest('.js-parent').parent()
            this.ajaxPath = '/local/ajax/forgotpasswd/?forgot_password=yes'

            this.init();

            $('html').addClass('js-inited-forgotpasswd');
		} else {
			console.error('No id in construktor')
			return null
		}
	}

	init()
	{
        this.initHandlers()
	}

	initHandlers()
	{
        // if ($('html').hasClass('js-inited-forgotpasswd')) {
        //     return null;
        // }

        this.$parent.on('submit', '.js-forgotpasswd__form', (e) => {
            e.preventDefault()
            this.query()
        })
	}

	query()
	{
        this.lock()

        $.ajax({
            method: 'POST',
            url: this.ajaxPath,
            data: this.$parent.find('.js-forgotpasswd__form').serialize(),
            dataType: 'html'
        })
        .done((data) => {
            this.$parent.html(data)
        })
        .fail((jqXHR, textStatus) => {
            console.log(textStatus)
        })
        .always(() => {
            this.lock()
        })
    }

	lock()
	{
        this.$parent.vlkinoLock()
    }

}
